import { render, staticRenderFns } from "./loginh5.vue?vue&type=template&id=7bcdf238&scoped=true"
import script from "./loginh5.vue?vue&type=script&lang=js"
export * from "./loginh5.vue?vue&type=script&lang=js"
import style0 from "./loginh5.vue?vue&type=style&index=0&id=7bcdf238&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcdf238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bcdf238')) {
      api.createRecord('7bcdf238', component.options)
    } else {
      api.reload('7bcdf238', component.options)
    }
    module.hot.accept("./loginh5.vue?vue&type=template&id=7bcdf238&scoped=true", function () {
      api.rerender('7bcdf238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/loginh5.vue"
export default component.exports